/**
 * Token Manager - Best Practice Implementation
 * Provides access to authStore token (in-memory only)
 * No localStorage usage for security
 */

import { authStore } from './authStore';

export function getAccessToken(): string | null {
  return authStore.getAccessToken();
}

export function setAccessToken(token: string | null): void {
  authStore.setAccessToken(token);
}


